$('.expand').on('click', function() {
    const button = $(this);
    const text = button.next('.txt');

    text.toggleClass('active');
    $(this).toggleClass('active');

    if (button.find('span').text() == 'Rozwiń opis') return button.find('span').text('Zwiń opis');

    button.find('span').text('Rozwiń opis');
});